import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

export type FormFieldError =
  | string
  | FieldError
  | Merge<FieldError, FieldErrorsImpl<any>>;

/**
 * Safely extract error message from react-hook-form FieldError
 * @param error - The error object from react-hook-form
 * @returns Error message string or undefined
 */
export const getErrorMessage = (
  error: FormFieldError | undefined,
): string | undefined => {
  if (!error) return undefined;

  if (typeof error === 'string') {
    return error;
  }

  if ('message' in error && typeof error.message === 'string') {
    return error.message;
  }

  return undefined;
};
